/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PolicyState;

(function (PolicyState) {
  PolicyState["POLICY_ACTIVE"] = "policy_active";
  PolicyState["POLICY_PAUSED"] = "policy_paused";
  PolicyState["POLICY_ELAPSED"] = "policy_elapsed";
  PolicyState["POLICY_CANCELLED"] = "policy_cancelled";
  PolicyState["POLICY_PENDING"] = "policy_pending";
  PolicyState["POLICY_ERROR"] = "policy_error";
  PolicyState["POLICY_VOID"] = "policy_void";
})(PolicyState || (PolicyState = {}));